import { ntvHasMethod } from './builtin-ntv.js';

const checkedPluginMethods = new Map<string, boolean>();

/**
 * 函数check window 一个变量是否存在，给一个最大的等待时间，如果超过这个时间还是没有这个变量，则认为是不存在的。
 * @param methodName Android的插件方法名, 支持 path 检测。
 * @param maxWaitTime 最大等待时间, 默认500毫秒
 * @returns
 */
export function awaitNtvPluginReady(
  methodName: string,
  maxWaitTime: number = 500
): Promise<boolean> {
  // 强制使用`send`方法作为检测
  methodName = 'send';
  // 如果已经检测过了，并且是已经存在了, 则直接返回
  if (checkedPluginMethods.has(methodName)) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    let checkTimeout: NodeJS.Timeout;

    const maxTimeoutId = setTimeout(() => {
      checkedPluginMethods.set(methodName, false);
      clearTimeout(checkTimeout);
      resolve(false);
    }, maxWaitTime);

    const checkMethod = () => {
      // 如果存在这个方法, 则认为Native已经准备好了, 只针对 android, 或者鸿蒙。iOS是应用程序启动的时候就初始化好了。
      if (ntvHasMethod(methodName)) {
        checkedPluginMethods.set(methodName, true);
        clearTimeout(maxTimeoutId);
        resolve(true);
      } else {
        checkTimeout = setTimeout(checkMethod, 100);
      }
    };

    checkMethod();
  });
}
